var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "filter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-2h18v18H-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Scroll Group 78",
    transform: "translate(2 2)",
    clipPath: "url(#filter_svg__a)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18994",
    d: "M2.087.75A1.1 1.1 0 0 0 1 1.85v.65a1.77 1.77 0 0 0 .479 1.212l3.365 3.583h0a3.581 3.581 0 0 1 1.015 2.5v3.175a.276.276 0 0 0 .406.247l1.916-1.044a.909.909 0 0 0 .47-.8V9.786a3.578 3.578 0 0 1 1-2.491l3.365-3.578a1.773 1.773 0 0 0 .484-1.213V1.85a1.1 1.1 0 0 0-1.086-1.1Z",
    fill: "none",
    stroke: "#e81e61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgFilter;